import { createElement } from 'react'
import { crmIcon } from '../icons'

/**
 * A CRM icon by name, decorative (`aria-hidden`). Render code uses this instead of
 * looking a component up during render, which `react-hooks/static-components`
 * rejects.
 */
export function CrmIcon({ name, className }: { name: string | null | undefined; className?: string }) {
  return createElement(crmIcon(name), { className, 'aria-hidden': true })
}
